module.exports = __webpack_public_path__ + "img/Остеохондропатия головки бедренной кости (болезнь Легга-Кальве-Пертеса).148855b7.jpeg";